// Google Rating Data - Update these values to reflect current Google reviews
export const googleRatingData = {
  rating: 4.9,
  reviewCount: 12,
  reviewUrl: 'https://share.google/UWpPK6gpmdpRv55oT'
};

// Helper function to format rating display
export const formatRatingDisplay = (rating) => {
  return rating.toFixed(1);
};

// Helper function to format review count with proper grammar
export const formatReviewCount = (count) => {
  return count === 1 ? `${count} review` : `${count} reviews`;
};
